import { Success, Failure, collect } from 'folktale/validation'
import isIsoDate from './isIsoDate.js'

export const validateProps = expectedProperties => obj =>
  collect(
    expectedProperties.map(key =>
      obj.hasOwnProperty(key) ? Success(obj) : Failure([`missing ${key} on parsed object`]),
    ),
  )

export const splitAndValidateId = idParam => {
  const splits = idParam.split('|')
  const validation =
    splits.length === 2
      ? validateUtcTime({
          resourceKey: splits[0],
          fromDateTimeUTC: splits[1],
        })
      : Failure([
          `Expected query parameter to contain a single "|" character, but there were ${splits.length -
            1}`,
        ])
  return validation
}

const validateUtcTime = value =>
  isIsoDate(value.fromDateTimeUTC)
    ? Success(value)
    : Failure([`Invalid UTC datetime from query string ${value.fromDateTimeUTC}`])

const findProductByResourceKey = (products, resourceKey) => {
  const match = products.find(p => p.ResourceKey === resourceKey)
  if (match) return match
  return products.find(p => p.childResourceKeys.includes(resourceKey))
}

export const joinProduct = products => value => {
  const product = value.productKey
    ? products.find(p => p.Key === value.productKey)
    : findProductByResourceKey(products, value.resourceKey)
  return {
    ...value,
    product,
  }
}
